

const NotFound = () => {
  return (
    <div className="container mt-4">
      <h1 className="bg-info">404 - Page Not Found</h1>
      <p>Sorry, the page you are looking for does not exist.</p>
      <a href="/">Go back to Home</a>
    </div>
  );
};

export default NotFound;
